import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  ExemptionType,
  sessionStorageECWizardExemptionTypes,
  ExemptionTypeCollection,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';

const useExemptionTypes = (
  gatewayEndPoint: string,
  alwaysReload: boolean,
): [ExemptionType[], NotificationData] => {
  const [exemptionTypes, setExemptionTypes] = React.useState(null);
  const [exemptionTypeNotification, setExemptionTypeNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getExemptionTypes = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      const exemptionTypesApi: ExemptionTypeCollection = await api.ecwizard.getExemptionTypesV41();

      Logging.Info('Load Exemption Types:', exemptionTypesApi.value);

      // Save the Exemptions to the Session Storage
      sessionStorage[sessionStorageECWizardExemptionTypes] = JSON.stringify(exemptionTypesApi.value);

      setExemptionTypes(exemptionTypesApi.value);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Exemption Types Read Error',
        description: 'Unable to read Exemption Types',
        error: error as ResponseError,
      };
      setExemptionTypeNotification(notification);
    }
  };

  React.useEffect(() => {
    if (!exemptionTypes) {
      // Read the Exemptions from the Session Storage if available
      if ((alwaysReload === false) && sessionStorage[sessionStorageECWizardExemptionTypes]) {
        setExemptionTypes(JSON.parse(sessionStorage[sessionStorageECWizardExemptionTypes]));
      } else {
        dispatch(getExemptionTypes());
      }
    }

    return (): void => {
      setExemptionTypeNotification(null);
    };
  }, []);

  return [exemptionTypes, exemptionTypeNotification];
};

export default useExemptionTypes;
